import React from "react"
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Label,
  Row,
  Toast,
  ToastBody,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import close from "../../../assets/images/icons/close.svg"
import BgPatternImage from "../../../assets/images/background-pattern.png"
import toast from "react-hot-toast"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useGetAssignedInvestorsListQuery } from "store/api/wealthpartnerapi/referrals/referrals.api"

function ShowInterestWp({
  data,
  open,
  setOpen,
  isLoading,
  title = "Show Interest",
  description = "Select any Name of Entity to show interest.",
  confirmButtonText = "Submit",
  showInterest,
  onSuccess,
  onClose,
}) {
  const { data: assignedInvestors } = useGetAssignedInvestorsListQuery()
  const validation = useFormik({
    initialValues: { investor_id: "" },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      handleSend(values)
    },
  })

  const handleSend = async (values) => {
    try {
      const { success, message } = await showInterest({
        ...data,
        ...values,
      }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toasterMessage" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <ToastBody>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <div className="delete-card-wrapper">
                <div>
                  <h4>{title}</h4>
                  {description}
                </div>
                <div className="close-icon" onClick={() => setOpen(false)}>
                  <img src={close} alt="" />
                </div>
              </div>
              <Row>
                <Col xl={12} className="mt-2">
                  <Label className="col-form-label" htmlFor="investor_id">
                    Name of Entity
                    <span className="error">*</span>
                  </Label>
                  <select
                    id="investor_id"
                    name="investor_id"
                    className="form-select"
                    value={validation.values.investor_id}
                    onChange={validation.handleChange}
                  >
                    <option value=""> Select Name of Entity</option>
                    {assignedInvestors?.data?.map((item, index) => (
                      <option key={`entities_${index}`} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {validation.errors.investor_id ? (
                    <FormFeedback type="invalid">
                      {validation.errors.investor_id}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>

              <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="cancel"
                >
                  Cancel
                </button>
                <Button className="approve btn btn-secondary" type="submit">
                  {isLoading ? <Spinners /> : confirmButtonText}
                </Button>
              </div>
            </Form>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default ShowInterestWp
